import React from 'react';

export const svgBookmark = (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 21">
    <path
      fill="none"
      fillRule="nonzero"
      stroke="#E57200"
      strokeWidth="1.4"
      d="M13.3 1H2.7C1.8 1 1 1.8 1 2.7V19l7-4 7 4V2.7c0-1-.8-1.7-1.8-1.7z"
    />
  </svg>
);
